<template lang="pug">
.input-text-area-component
    label.input-label-text-area {{ label }}
    textarea.input-text-area(
        :id='id',
        type='text-area',
        :placeholder='placeholder',
        :value='value',
        @input='$emit("input", $event.target.value)'
        :disabled='disabled'
    )
</template>

<script>
export default {
    name: 'TextAreaInputComponent',
    props: {
        value: {},
        id: {
            type: String,
            default: () => `textarea-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },
};
</script>

<style>
.input-text-area-component {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-wrap: wrap;
}

.input-text-area {
    margin: 5px 0 10px 0;
    padding: 3px;
    height: 100px;
    border: 2px solid var(--primary-light-green) !important;
    border-radius: 5px;
}

.input-text-area:focus-visible {
    border: 2px solid var(--primary-green) !important;
    border-radius: 5px;
    outline: none;
}
</style>
